<template>
  <div>
    <subscribe v-if="showPlansPopup" :subscribePayload="subscribepayload" :closePopup="() => toggleSubscribePopup(false)" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Utility from "@/mixins/Utility.js";

export default {

  data() {
    return {
      subscribepayload: null,
      showPlansPopup: false,
      couponCode : null,
      planid : null
    };
  },

  computed: {
      ...mapGetters(["subscriberid"]),
  },

mounted() {
  document.title= "Unlock Premium Entertainment: Buy KEE Subscription Plans";     
  var allMetaElements = document.getElementsByTagName('meta');
  for(var metaValue = 0; metaValue < allMetaElements.length; metaValue ++) {
  if (allMetaElements[metaValue].getAttribute("name") == "description") { 
       allMetaElements[metaValue].setAttribute('content',"Buy the ideal KEE premium subscription plan for access to 500+ Malayalam Movies and Webseries."); 
  } 
 
  if(allMetaElements[metaValue].getAttribute("property") == "og:description") { 
    allMetaElements[metaValue].setAttribute('content', "Buy the ideal KEE premium subscription plan for access to 500+ Malayalam Movies and Webseries."); 
  } 

 if(allMetaElements[metaValue].getAttribute("name") == "twitter:description") { 
     allMetaElements[metaValue].setAttribute('content', "Buy the ideal KEE premium subscription plan for access to 500+ Malayalam Movies and Webseries."); 
  } 


  if(allMetaElements[metaValue].getAttribute("property") == "og:title") { 
     allMetaElements[metaValue].setAttribute('content', "Unlock Premium Entertainment: Buy KEE Subscription Plans"); 
  }

  if(allMetaElements[metaValue].getAttribute("name") == "twitter:title") { 
     allMetaElements[metaValue].setAttribute('content', "Unlock Premium Entertainment: Buy KEE Subscription Plans"); 
  }
}

    this.showPlansPopup = true;

    this.planid = this.$route.params.planId;
    this.couponCode = this.$route.params.coupon;

    console.log("THIS IS FROM SEE ALL PLANS --- > ", this.planid, this.couponCode)

    let payload = {
      listPlans: "ALL",
      listType: "onlySubscribe"
    };

    this.subscribepayload = payload;
  },

  methods: {

    ...mapMutations(["setPlanDeeplinkPath"]),

    toggleSubscribePopup(state) {
      let currentLanguage = this.getCurrentLanguageUrlBase();

      this.$router.push({ name: "Home", params: { lang: currentLanguage } });
    },
  },

  components: {
    subscribe: () => import(/* webpackChunkName: "subscribe" */ "@/components/Popups/Subscribe.vue"),
  },
   mixins: [Utility]
};
</script>

<style></style>
